
/* ---------- Subscribe & Save modal (digital product page) ---------- */
(function () {
  var modal = document.querySelector('[data-subscribe-modal]');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 200);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-subscribe-open]')) {
      openModal();
    }
    if (e.target.closest('[data-subscribe-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();
